export default __webpack_public_path__ + "static/media/disabled-concern-icon.c3d9e6d4.svg";